module.exports = __webpack_public_path__ + "static/scale-model-of-blue-lake-regional-park-in-gresham-oregon-bf5cc7840143a744a2e21c91a7094f4e.png";